import React from 'react';
import Styles from './max-students-modal-styles.scss';
import { UserExceededIcon } from '../../icons';
import { ButtonBorderedKV } from '@/presentation/pages/global-components-example/components';
const MaxStudentsModal = ({ onClick, enterpriseFunction }) => {
    return (React.createElement("div", { className: Styles.maxStudentsModalWrap },
        React.createElement("div", { className: Styles.icon },
            React.createElement(UserExceededIcon, null)),
        React.createElement("div", { className: Styles.header },
            React.createElement("h3", null, "Student limit exceeded")),
        React.createElement("div", { className: Styles.text },
            React.createElement("p", null, "Your account type has a limit of 49 students. To continue, reduce the number of students you are trying to add to meet the limit.")),
        React.createElement("hr", { className: Styles.divider }),
        React.createElement("div", { className: Styles.message },
            React.createElement("h4", null,
                "For 50 or more students, select an",
                ' ',
                React.createElement("span", { onClick: () => enterpriseFunction && enterpriseFunction() }, "Schools & Beyond"),
                " subscription")),
        React.createElement("div", { className: Styles.button },
            React.createElement(ButtonBorderedKV, { onClick: () => {
                    if (onClick)
                        onClick();
                }, type: "button" }, "Ok"))));
};
export default MaxStudentsModal;
